module.exports = __webpack_public_path__ + "media/images/emblems/Oberbueren_blazono-88d9e292f479ee84b6add128c12579fd.png";